import { PipeTransform, Pipe } from '@angular/core';
import { I18n } from '../entities/i18n.entity';

@Pipe({ name: 'i18n' })
export class I18nPipe implements PipeTransform {
  transform(i18ns: I18n[], language: string, defaultValue?: string): any {
    // langcode used on Unity3D is ugly... Please use iso code... ;-( For backward compatibility, we need to convert it to iso code
    const langIso = language?.toLowerCase().substring(0, 2); // Force to convert to iso code
    const translated =
      i18ns?.find((i18n) => {
        return i18n?.language?.toLowerCase()?.substring(0, 2) === langIso;
      })?.value || '';
    if (translated && translated !== '') {
      return translated;
    } else {
      return defaultValue || '';
    }
  }
}
